import { getExtendedFormatObject } from '../../content/style';
import { getDimensionsConfig } from '../../config/dimension.config';
import { cloneObject } from '../../utilities';
import { Content } from '../../models';
import { NodeGraph } from './utilities';

// METHOD: Echart Sankey [Validator]
export const validateECSankey = (content) => {
  const { type, typeSpecific } = content;
  const { eChart } = typeSpecific;

  if (!eChart.subType) {
    eChart.subType = 'sankey';
  }

  // handle sankey
  if (eChart.subType === 'sankey') {
    eChart.sankey = eChart.sankey ?? {};
    if (!eChart.sankey.version) {
      eChart.sankey = genesisSankeyChart();

      delete typeSpecific.echarts; // Old Configs

      typeSpecific.dimensions = getDimensionsConfig(content.type); // TODO refactor this to content?

      // Assign fields to dimensions
      const miscFields: string[] = [];
      const { fields, dimensions } = typeSpecific;
      for (const dimension of dimensions) {
        if (dimension.requirements.fieldTypes.includes('miscField') && !dimension.fieldName) {
          const field: any = Object.values(fields).find((_field: any) => _field.fieldType === 'miscField' && !miscFields.includes(_field.fieldName));
          if (field) {
            dimension.fieldName = field.fieldName;
            miscFields.push(field.fieldName);
          }
        }

        if (dimension.requirements.fieldTypes.includes('valueField')) {
          const field: any = Object.values(fields).find((_field: any) => _field.fieldType === 'valueField');
          if (field) dimension.fieldName = field.fieldName;
        }
      }
    }

    if (eChart.sankey.version < 2) {
      eChart.sankey.editorOptions.advancedEdit = 1;
      eChart.sankey.editorOptions.defaultNode.edgeQuillHoverVisible = true;
      eChart.sankey.editorOptions.defaultNode.lineStyle = {
        color: 'gradient',
        opacity: 0.9,
      };
      eChart.sankey.version = 2;
    }

    if (eChart.sankey.version < 3) {
      eChart.sankey.editorOptions.defaultNode.tooltipQuillEnabled = true;
      eChart.sankey.editorOptions.defaultNode.tooltipQuill = JSON.stringify(tooltipQuill);
      eChart.sankey.version = 3;
    }
  }
};

const defaultQuillStyle = getExtendedFormatObject();

const defaultEdgeQuillStyle = getExtendedFormatObject();

const defaultNodeProps = { color: '#5cbacf' };

const quill = {
  ops: [{ insert: { echartsValue: { fieldName: 'b', title: 'Node name' } } }],
};

const edgeQuill = {
  ops: [
    {
      insert: { echartsValue: { fieldName: 'c', title: 'Edge value' } },
      attributes: { color: '#000000' }, // Default
    },
  ],
};

const tooltipQuill = {
  ops: [
    {
      insert: { echartsValue: { fieldName: 'c', title: 'Edge value' } },
      attributes: { color: '#000000' }, // Default
    },
  ],
};

const genesisSankeyChart = () => ({
  version: 1,
  editorOptions: {
    defaultNode: getDefaultNodeProp(),
    customNodes: [],
    levelNodes: [
      { id: 0, touched: false },
      { id: 1, touched: false },
    ],
    labelPosition: 'inside',
    orient: 'horizontal',
  },
  eChartOptions: {
    series: {
      type: 'sankey',
      draggable: false,
      orient: 'horizontal',
      nodeAlign: 'justify',
      nodeWidth: 20,
      nodeGap: 8,
      right: '5%',
      itemStyle: {
        color: '#5cbacf', // TODO fetch from style.colors2
      },
      lineStyle: {
        color: '#aaa',
        curveness: 0.5,
      },
      selectedMode: false,
      label: {
        position: 'left',
      },
      levels: [
        {
          depth: 0,
          label: {
            position: 'right',
          },
        },
      ],
      emphasis: {
        focus: 'adjacency',
        blurScope: 'coordinateSystem',
        edgeLabel: {
          show: true,
          distance: 5,
        },
      },
    },
  },
});

const getDefaultNodeProp = () => ({
  id: 'default',
  // Node label
  quill: JSON.stringify(quill),
  valueStyle: cloneObject(defaultQuillStyle),
  quillBackground: { backgroundColor: '#ffffff' },
  // Edge label
  edgeQuillEnabled: true,
  edgeQuill: JSON.stringify(edgeQuill),
  edgeValueStyle: cloneObject(defaultEdgeQuillStyle),
  edgeQuillBackground: { backgroundColor: '#ffffff' },

  color: '#5cbacf',
});

export const validateNonCircularData = (data: Record<string, any>[], sourceField: string, targetField: string): boolean[] => {
  if (!sourceField || !targetField) return data.map((row) => true);
  const links: [string, string][] = data.map((row) => [row[sourceField], row[targetField]]);

  const graph = new NodeGraph();
  return graph.validate(links);
};
